import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import UtilsFormule from "../../../utils/UtilsFormule";
import { Alert, Snackbar } from "@mui/material";

const DataTableListAbonnementDetails = ({ listAbonnement }) => {
  const navigate = useNavigate();
  const [infoAlertText, setInfoAlertText] = useState();
  const [openInfoAlert, setOpenInfoAlert] = useState(false);
  const { SearchBar } = Search;

  const MyExportCSV = (props) => {
    const handleClick = () => {
      props.onExport();
    };
    return (
      <div>
        <button className="btn btn-dark" onClick={handleClick}>
          <i className="fas fa-download"></i> Télécharger CSV
        </button>
      </div>
    );
  };

  function dateFormatter(cell, row) {
    return (
      <span>
        {UtilsFormule.formatDate(row.creationDate)}
      </span>
    );
  }
  function clientFormatter(cell, row) {
    return (
      <span>
        {row.client.firstName} {" "}{row.client.lastName}
      </span>
    );
  }

  function phoneFormatter(cell, row) {
    return (
      <span>
        {row.client.phoneNumber} 
      </span>
    );
  }

  function productFormatter(cell, row) {
    return (
      <span>
        {row.abonnement.product.barcode} - {row.abonnement.product.name}
      </span>
    );
  }

  function libelleFormatter(cell, row) {
    return (
      <span>
        {row.ref} - {row.name}
      </span>
    );
  }

  const columns = [
    // {
    //   dataField: "id",
    //   text: "Libellé",
    //   formatter: libelleFormatter,
    //   headerStyle: () => {
    //     return { width: "20%" };
    //   },
    // },
    {
      dataField: "id",
      text: "Produit",
      align: "center",
      headerAlign: "center",
      formatter: productFormatter,
      headerStyle: () => {
        return { width: "15%" };
      },
    },
    {
      dataField: "creationDate",
      text: "DC",
      align: "center",
      headerAlign: "center",
      formatter: dateFormatter,
      headerStyle: () => {
        return { width: "15%" };
      },
    },
    {
      dataField: "id",
      text: "Client",
      align: "center",
      headerAlign: "center",
      formatter: clientFormatter,

      headerStyle: () => {
        return { width: "8%" };
      },
    },
    {
      dataField: "id",
      text: "N°",
      align: "center",
      headerAlign: "center",
      formatter: phoneFormatter,

      headerStyle: () => {
        return { width: "8%" };
      },
    },
    {
      dataField: "nbrAbonnementRestant",
      text: "Nombre restant",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "10%" };
      },
    },
    // {
    //   dataField: "initialPricePerOne",
    //   text: "Prix Initial",
    //   align: "center",
    //   headerAlign: "center",
    //   headerStyle: () => {
    //     return { width: "10%" };
    //   },
    // },
    {
      dataField: "isActive",
      text: "Actif",
      align: "center",
      headerAlign: "center",
      formatter: (cell) => (cell ? "Oui" : "Non"),
      headerStyle: () => {
        return { width: "8%" };
      },
    },
  ];

  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };

  function handleTableChange({ products }) {
    return products;
  }

  const pageButtonRenderer = ({
    page,
    active,
    disable,
    title,
    onPageChange,
  }) => {
    const handleClick = (e) => {
      e.preventDefault();
      onPageChange(page);
    };
    const activeStyle = {};
    if (active) {
      activeStyle.backgroundColor = "black";
      activeStyle.color = "white";
    } else {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    return (
      <li className="page-item">
        <button
          className="btn btn-dark"
          onClick={handleClick}
          style={activeStyle}
        >
          {page}
        </button>
      </li>
    );
  };

  const options = {
    pageButtonRenderer,
  };

  return (
    <>
      <ToolkitProvider
        keyField="id"
        data={listAbonnement}
        columns={columns}
        onTableChange={handleTableChange}
        exportCSV
        search
      >
        {(props) => (
          <div>
            <div className="row ml-0">
              <div>
                <SearchBar
                  {...props.searchProps}
                  className="custome-search-field"
                  style={{ color: "black" }}
                  placeholder="Chercher"
                />
              </div>
              <div className="ml-auto mr-0">
                <MyExportCSV {...props.csvProps} />
              </div>
            </div>
            <BootstrapTable
              {...props.baseProps}
              pagination={paginationFactory(options)}
              striped
              hover
              condensed
            />
          </div>
        )}
      </ToolkitProvider>

      {openInfoAlert && (
        <Snackbar
          open={openInfoAlert}
          autoHideDuration={2000}
          onClose={handleInfoClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        >
          <Alert variant="filled" onClose={handleInfoClose} severity="info">
            {infoAlertText}
          </Alert>
        </Snackbar>
      )}
    </>
  );
};

export default DataTableListAbonnementDetails;
